<h5 mat-dialog-title>{{dialogName}}</h5>
<mat-dialog-content class="mat-typography">
    <mat-vertical-stepper [linear]="true" #stepper>
        <mat-step [stepControl]="nameFormGroup">
            <form [formGroup]="nameFormGroup">
                <ng-template matStepLabel>Customer Mapping Name</ng-template>
                <mat-form-field subscriptSizing="dynamic" style="width: 100%;">
                    <mat-label>Customer Mapping Name <span class="required"></span></mat-label>
                    <input matInput placeholder="Customer Mapping Name" formControlName="firstCtrl">
                </mat-form-field>
                <div class="step-actions">
                    <button mat-stroked-button matStepperNext>Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="clientFormGroup">
            <div class="container">
                <ng-template matStepLabel>Client Mapping</ng-template>
                @if (!isLoadingResults && clientPropertiesKeys) {
                <form [formGroup]="clientFormGroup">
                    <div formArrayName="clientControlArray">
                        <h6>Note: Add values for required properties only</h6>
                        @for (clientKey of clientPropertiesKeys; track clientKey; let i = $index) {
                        <div>
                            <mat-form-field subscriptSizing="dynamic" style="width: 100%;">
                                <mat-label>
                                    {{getClientDisplayName(clientKey)}}
                                    @if (isControlRequired(clientKey) && (us || asia)) {
                                    <span></span>
                                    }
                                </mat-label>
                                <input matInput placeholder="Enter value" [formControlName]="i"  [required]="isControlRequired(clientKey)">
                            </mat-form-field>
                        </div>
                        }
                    </div>
                    <div class="step-actions">
                        <button mat-stroked-button matStepperPrevious>Back</button>
                        <button mat-stroked-button matStepperNext>Next</button>
                    </div>
                </form>
                }
                @if (isLoadingResults) {
                <div class="loading-shade">
                    @if (isLoadingResults) {
                    <mat-spinner></mat-spinner>
                    }
                </div>
                }
            </div>
        </mat-step>
        <mat-step [stepControl]="rentokilFormGroup">
            <div class="container">
                <ng-template matStepLabel>Rentokil Mapping</ng-template>
                @if (!isLoadingResults && rentokilPropertiesKeys) {
                <form [formGroup]="rentokilFormGroup">
                    <div formArrayName="rentokilControlArray">
                        <h6>Note: Add values for required properties only</h6>
                        @for (rentokilKey of rentokilPropertiesKeys; track rentokilKey; let i = $index) {
                        <div>
                            @if (rentokilKey !== 'invoicePDFAllowed' && rentokilKey !== 'invoiceDataAllowed') {
                            <div>
                                @if (rentokilKey === 'isInvoicingAllowed') {
                                <div style="margin-bottom: 16px; margin-top: 8px;">
                                    <mat-slide-toggle [disabled]="isNewForm" [formControlName]="i" color="primary">
                                        {{getRentokilDisplayName(rentokilKey)}}
                                        @if (isRentokilControlRequired(rentokilKey)) {
                                        <span class="required"></span>
                                        }
                                    </mat-slide-toggle>
                                </div>
                                }
                                @if (rentokilKey !== 'isInvoicingAllowed' && rentokilKey !== 'workOrderType' &&
                                rentokilKey !== 'MappedTo') {
                                <mat-form-field subscriptSizing="dynamic" style="width: 100%;">
                                    <mat-label>
                                        {{getRentokilDisplayName(rentokilKey)}}
                                        @if (isRentokilControlRequired(rentokilKey)) {
                                        <span></span>
                                        }
                                    </mat-label>
                                    <input matInput placeholder="Enter value" [formControlName]="i"  [required]="isRentokilControlRequired(rentokilKey)">
                                </mat-form-field>
                                }
                                @if (rentokilKey === 'workOrderType') {
                                <mat-form-field subscriptSizing="dynamic" style="width: 100%;">
                                    <mat-label>
                                        {{getRentokilDisplayName(rentokilKey)}}
                                        @if (isRentokilControlRequired(rentokilKey)) {
                                        <span class="required"></span>
                                        }
                                    </mat-label>
                                    <mat-select [formControlName]="i" name="workOrder"  [required]="isRentokilControlRequired(rentokilKey)">
                                        @for (workOrder of workOrders; track workOrder) {
                                        @if (us == true || asia == true) {
                                        <mat-option [value]="workOrder">
                                            {{workOrder}}
                                        </mat-option>
                                        }
                                        }
                                        @for (workOrder of workOrdersUk; track workOrder) {
                                        @if (europe == true) {
                                        <mat-option [value]="workOrder">
                                            {{workOrder}}
                                        </mat-option>
                                        }
                                        }
                                    </mat-select>
                                </mat-form-field>
                                }
                                @if (rentokilKey === 'MappedTo') {
                                <mat-form-field subscriptSizing="dynamic" style="width: 100%;">
                                    <mat-label>
                                        {{getRentokilDisplayName(rentokilKey)}}
                                        @if (isRentokilControlRequired(rentokilKey)) {
                                        <span></span>
                                        }
                                    </mat-label>
                                    <mat-select [formControlName]="i" name="mapped"  [required]="isRentokilControlRequired(rentokilKey)">
                                        @for (mapped of mappedTo; track mapped) {
                                        <mat-option [value]="mapped">
                                            {{mapped}}
                                        </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                }
                            </div>
                            }
                        </div>
                        }
                        @if (rentokilPropertiesKeys.includes('invoicePDFAllowed') ||
                        rentokilPropertiesKeys.includes('invoiceDataAllowed')) {
                        <div>
                            <label style="display: block; margin-bottom: 12px;font-weight: 600;">Invoice Type</label>
                            <div style="display: flex; flex-direction: column; margin-left: 20px;margin-bottom: 5%;">
                                @if (rentokilPropertiesKeys.includes('invoiceDataAllowed')) {
                                <mat-checkbox [formControlName]="getFormControlIndex('invoiceDataAllowed')"
                                    color="primary">
                                    {{getRentokilDisplayName('invoiceDataAllowed') === 'Invoice Data Allowed' ?
                                    'Invoice' : getRentokilDisplayName('invoiceDataAllowed')}}
                                </mat-checkbox>
                                }
                                @if (rentokilPropertiesKeys.includes('invoicePDFAllowed')) {
                                <mat-checkbox [formControlName]="getFormControlIndex('invoicePDFAllowed')"
                                    color="primary">
                                    {{getRentokilDisplayName('invoicePDFAllowed') === 'Invoice PDF Allowed' ? 'PDF' :
                                    getRentokilDisplayName('invoicePDFAllowed')}}
                                </mat-checkbox>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    <div class="step-actions">
                        <button mat-stroked-button matStepperPrevious>Back</button>
                    </div>
                </form>
                }
                @if (isLoadingResults) {
                <div class="loading-shade">
                    @if (isLoadingResults) {
                    <mat-spinner></mat-spinner>
                    }
                </div>
                }
            </div>
        </mat-step>
    </mat-vertical-stepper>
</mat-dialog-content>
<div mat-dialog-actions>
    <button mat-stroked-button (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!validateForm()">Save</button>
</div>